export default (theme) => ({
    '@keyframes fadeIn': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    popover: {
        maxWidth: '308px !important',
        padding: '16px !important',
        borderRadius: '12px !important',
        boxShadow:
            '0 8px 10px 0 rgba(39, 60, 80, 0.2), 0 6px 30px 0 rgba(39, 60, 80, 0.12), 0 16px 24px 0 rgba(39, 60, 80, 0.14) !important',
        backgroundColor: `${theme.colors.semantic.info500} !important`,

        '& span': {
            color: theme.colors.primary.white,
        },
        transition: 'none !important',
        opacity: 0,
        animationName: '$fadeIn',
        animationDuration: '.4s',
        animationIterationCount: 1,
        animationFillMode: 'forwards',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 8,
    },
    bottom: {
        marginTop: 12,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    link: {
        color: theme.colors.primary.white,
        '&:hover': {
            color: theme.colors.primary.white,
        },
    },
    button: {
        marginLeft: 8,
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
    },
});
